import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { BrandService } from '../../services/brand-config.service';
import { RestService } from '../services/rest.service';
import { TranslatePipe } from '../pipes/translate.pipe';
import { RtlService } from '../services/rtl.service';
import { PlatformService } from '../services/platform.service';

@Component({
  selector: 'app-welcome',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    TranslatePipe,
  ],
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.scss',
})
export class WelcomeComponent {
  brand: string = '';
  constructor(
    private brandService: BrandService,
    private restService: RestService,
    public rtlService: RtlService,
    private router: Router,
    private platform: PlatformService
  ) {
    this.brand = this.brandService.config.brandName;

    this.restService
      .request({
        path: 'ping-server',
        method: 'GET',
      })
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.error(error);
      });
    // Native entry is the login screen (it links to signup for new users).
    // After auth, the spinner / landAfterAuth route new users through
    // onboarding → home and existing users straight to home.
    // Web stays a lead funnel: jump straight into the test flow.
    if (this.platform.isNative) {
      this.router.navigate(['/login']);
    } else {
      this.router.navigate(['/app/new-test']);
    }
  }

  navigateToOnboarding() {
    console.log('WelcomeComponent: navigating to onboarding');
    this.router.navigate(['/app/onboarding']);
  }

  navigateToLogin() {
    console.log('WelcomeComponent: navigating to login');
    this.router.navigate(['/login']);
  }
}
